import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Banner from "@/components/ui/banner";
import type { BannerSize, ButtonVariant } from "@/components/ui/banner";

interface Props {
  contractId: string;
  title?: string;
  size?: BannerSize;
  buttonVariant?: ButtonVariant;
  onDismiss?: () => void;
}

const DealClosedWonBanner: React.FC<Props> = ({
  contractId,
  title,
  size,
  buttonVariant,
  onDismiss
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Banner
      variant="success"
      size={size}
      buttonVariant={buttonVariant}
      title={title ?? t("deals.dealView.closedWonBanner.message")}
      buttonText={t("deals.dealView.closedWonBanner.viewContract")}
      onButtonClick={() => navigate(`/contracts/${contractId}`)}
      showCloseButton={true}
      onClose={onDismiss}
    />
  );
};

export { DealClosedWonBanner };
